<template>
  <tr>
    <td>
      <input
        type="text"
        v-model="formData.remarks_management"
        @keydown.enter="updateLaporanKejadian"
        @blur="updateLaporanKejadian"
      />
    </td>
    <td>{{ data.id }}</td>
    <td>{{ formatDate(data.tgl) }}</td>
    <td>
      {{ data.container.no_container }}/{{ data.container.kc }} -
      {{ data.vessel.nama_kapal }} Voy: {{ data.vessel.voy }}
    </td>
    <td>{{ data.deskripsi_kejadian }}</td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  name: "RemarksManagement",
  props: ["data"],
  data() {
    return {
      formData: {
        remarks_management: ""
      }
    };
  },
  methods: {
    async updateLaporanKejadian() {
      await axios
        .put(`add-remarks/${this.data.id}`, this.formData)
        .then(res => {
          //   this.$emit("fetch-data");
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  }
};
</script>

<style scoped>
input[type="text"] {
  outline: none;
  border: 1px solid lightgray;
  padding: 0 0.5em;
  width: 100%;
}
</style>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
